import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import featurePageStore from '@src/pages/main/components/featurePage/store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import toWebpImage from '@src/utils/to-webp-image';
// import AgeAppropriateTips from '@src/components/age-appropriate-tips';

const styles = require('./index.less');

const featurePage = ({ store }) => {
  store.use();
  const handleSlideClick = e => {
    const target = e.target;
    if (target.className === 'play') {
      const item = store.featureList[target.getAttribute('data-btn')];
      store.onClickPlayPv(item.item_video);
    }
  };
  const featureSwiper = () => {
    if (store.featureList?.length > 0) {
      return (
        <div className="featureSwiper" onClick={handleSlideClick}>
          <BaseSwiper store={store.featureSwiper}>
            {store.featureList?.map((item, index) => {
              return (
                <div className={cx('featureItem')} key={index}>
                  <div
                    className={cx('featureImgs')}
                    style={{
                      backgroundImage: `url(${item.item_img && item.item_img})`
                    }}
                  />
                  <div
                    data-btn={index}
                    className="play"
                    style={{
                      backgroundImage: ` url(${toWebpImage(require('./images/play.png'))})`
                    }}
                  />
                  <div
                    className="feature"
                    style={{
                      backgroundImage: ` url(${toWebpImage(require('./images/feature.png'))})`
                    }}
                  />
                  <div className="delBox">
                    <div className="info">
                      <div
                        className="num"
                        style={{
                          backgroundImage: ` url(${item.num_img && item.num_img})`
                        }}
                      />
                      <div className="text">
                        {item.text}
                        {(store.featureSwiper.activeIndex + 1).toString().length === 1
                          ? '0' + (store.featureSwiper.activeIndex + 1)
                          : store.featureSwiper.activeIndex + 1}/{store.featureList.length}
                      </div>
                      <div className="line" />
                    </div>
                    <div className="text" dangerouslySetInnerHTML={{ __html: item.item_title }} />
                  </div>
                </div>
              );
            })}
          </BaseSwiper>
        </div>
      );
    }
  };
  const indicatorBox = () => {
    if (store.featureList?.length > 0) {
      return (
        <div className="indicatorBox">
          <Link className="prevBtn" onClick={store.featureSwiper.goPrev} />
          <div className="indicator">
            {store.featureList?.map((item, index) => {
              return <div key={index} className={cx('indicator-item', store.featureSwiper.activeIndex === index && 'indicator-item-act')} />;
            })}
          </div>
          <div className="text">Next </div>
          <Link className="nextBtn" onClick={store.featureSwiper.goNext} />
        </div>
      );
    }
  };
  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      {featureSwiper()}
      {indicatorBox()}
    </div>
  );
};

export default wrapStore(featurePage, featurePageStore);
